module.exports = "/assets/site/images/tomegsport_miskolc.jpg?9559d3a7d8c7ce796dc9411a867f6d03";